const cnpjMask = [
  /[0-9A-Za-z]/,
  /[0-9A-Za-z]/,
  '.',
  /[0-9A-Za-z]/,
  /[0-9A-Za-z]/,
  /[0-9A-Za-z]/,
  '.',
  /[0-9A-Za-z]/,
  /[0-9A-Za-z]/,
  /[0-9A-Za-z]/,
  '/',
  /[0-9A-Za-z]/,
  /[0-9A-Za-z]/,
  /[0-9A-Za-z]/,
  /[0-9A-Za-z]/,
  '-',
  /\d/,
  /\d/,
];

export default cnpjMask;
